import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import ComicDetail from "../pages/comic/page";
import Reader from "../pages/read/page";
import Rank from "../pages/rank/page";
import About from "../pages/about/page";
import Faq from "../pages/faq/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/category", element: <Category /> },
  { path: "/comic/:id", element: <ComicDetail /> },
  { path: "/read/:id", element: <Reader /> },
  { path: "/rank", element: <Rank /> },
  { path: "/about", element: <About /> },
  { path: "/faq", element: <Faq /> },
  { path: "*", element: <NotFound /> },
];

export default routes;